import { Component, Input, OnInit, AfterViewInit, OnChanges } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit {

  @Input("chartDataSource") chartData:any;

  private barChart:any;

  public barChartWidth:string = "100%";

  constructor() { }

  ngOnInit(): void {
    if(this.chartData != undefined)
    this.loadData();
  }


  loadData():void{
    let option = this.chartOptions();
    let bgColors = this.getBackgroundColors();
    this.setBarChartWidth();

    this.barChart = new Chart("barChart", {
      type: 'bar',
      data: {
        labels: (this.chartData && this.chartData.length > 0)? this.chartData.labelName : [],
        datasets: [
          {
            label: "hours",
            backgroundColor: bgColors,
            data: (this.chartData && this.chartData.length > 0)? this.chartData.workingTime : [],
           
          }
        ],
     },
      options: option
      },
    );
  }

  updateChartData(){
    this.setBarChartWidth();
    let option = this.chartOptions();

    if(this.barChart == undefined){
      this.loadData();
    }else{

      let bgColors = this.getBackgroundColors();
      this.barChart.data.datasets.length = 0;
  
      this.barChart.update();
      
      let updateData = {
          labels: this.chartData.labelName,
          datasets: [
            {
              barThickness: 18,
              backgroundColor: bgColors,
              data: this.chartData.workingTime
            }
          ],
          options: option
      };
      
      this.barChart.data = updateData;
      this.barChart.update();
    }

  }

  chartOptions():Object{
    let options= {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            scales: {
              xAxes: [{
                barThickness: 10,
                gridLines: {
                    zeroLineColor: '#e1e8ef'
                },
                ticks: {
                  beginAtZero: true,
                  fontColor: "#7886a0",
                  autoSkip: false
                }
              }],
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                    fontColor: "#7886a0",
                    callback: function(label, index, labels) {
                      return Math.floor((label/(60*60)))+'h ';
                    },
                },
              }],
           },
           tooltips: {
            enabled: true, 
            displayColors: false,
            xPadding: 15,
            yPadding: 15,
            callbacks: {
                // title: function(tooltipItem, data) {
                //   console.log(tooltipItem);
                //     return `${tooltipItem.label}`;
                // },
                label: function(tooltipItem, data) {
                  const hours = Math.floor((+tooltipItem.value / 60) / 60);
                  const minutes = Math.floor(+tooltipItem.value / 60) % 60;
                  return `${hours} H : ${minutes} M`
               }
        
            }
        
          },
          animation: {
            duration: 0, 
            onComplete: function() {
              if (!this.rectangleSet) {
               let scale = window.devicePixelRatio;

               let sourceCanvas = this.chart.canvas;
               let copyWidth = this.chart.chart.scales['y-axis-0'].width - 10;
               let copyHeight = this.chart.chart.scales['y-axis-0'].height + this.scales['y-axis-0'].top + 10;

               const canvas = <HTMLCanvasElement> document.getElementById('chartAxis');
               const targetCtx = canvas.getContext('2d');

                targetCtx.scale(scale, scale);

                targetCtx.canvas.width = copyWidth * scale;
                targetCtx.canvas.height = copyHeight * scale;

                targetCtx.canvas.style.width = `${copyWidth}px`;
                targetCtx.canvas.style.height = `${copyHeight}px`;
                targetCtx.drawImage(
                  sourceCanvas,
                  0,
                  0,
                  copyWidth * scale,
                  copyHeight * scale,
                  0,
                  0,
                  copyWidth * scale,
                  copyHeight * scale
                );

              }
            },
           
          }
      }
    return options;
  }

  getBackgroundColors(){
    let colors =  ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"];
    let bgColors = [];

    if(this.chartData && this.chartData.labelName.length >0){
      for (var i = 0; i < this.chartData.labelName.length; i++) {
        bgColors.push(colors[i % colors.length]);  
      }
    }

    return bgColors;
  }

  private setBarChartWidth():void{
    this.barChartWidth = (this.chartData.labelName.length > 15 ) ?  (this.chartData.labelName.length * 50)+ "px" : "100%";
  }

}
